// Step 22 — buyer interest-signal card.
//
// Reads `intel.interest` from `aggregate_buyer_intelligence`. The
// backend guarantees the item is always labeled INFERENCE (Step 11
// rule) — we render that badge explicitly so a reader can never
// mistake it for a fact.

import { AIEmpty, AISection } from "../AIPrimitives";

export default function AIBuyerInterestCard({ intel }) {
  const interest = intel?.interest;
  if (!interest) {
    return (
      <AISection title="Intressesignal">
        <AIEmpty
          title="Ingen intressesignal registrerad"
          hint="Signalen dyker upp när ett köpar-svar har analyserats."
        />
      </AISection>
    );
  }
  const prov = interest.provenance || null;
  return (
    <AISection title="Intressesignal">
      <div className="qai-buyer-interest">
        <div className="qai-buyer-interest-head">
          <span
            className="qai-finding-badge"
            data-tone="origin"
            title="Backend markerar alltid interest_signal som inferens (Step 11)."
          >
            Slutsats
          </span>
          <span className="qai-buyer-interest-value">{interest.signal}</span>
        </div>
        {prov && (
          <div className="qai-buyer-interest-prov">
            {prov.source_inbound_message_id != null && (
              <span>Inkommande #{prov.source_inbound_message_id}</span>
            )}
            {prov.analysis_version != null && (
              <span> · Analys v{prov.analysis_version}</span>
            )}
            {prov.captured_at && (
              <span> · {String(prov.captured_at).slice(0, 10)}</span>
            )}
          </div>
        )}
      </div>
    </AISection>
  );
}
